export default "__VITE_ASSET__BtXK0G0W__"